{
  "name": "pu-organisme-formation",
  "version": "1.0.18",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "pack": "ng pack",
    "test-ci": "ng test --no-watch --no-progress --browsers=ChromeHeadlessNoSandbox",
    "lint": "npx eslint \"src/**/*.{js,jsx,ts,tsx,html,css}\" --quiet --fix",
    "format": "npx prettier \"src/**/*.{js,jsx,ts,tsx,html,css,scss}\" --write",
    "prepare": "husky install"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.17",
    "@angular/cdk": "21.2.14",
    "@angular/common": "21.2.17",
    "@angular/compiler": "21.2.17",
    "@angular/core": "21.2.17",
    "@angular/forms": "21.2.17",
    "@angular/platform-browser": "21.2.17",
    "@angular/platform-browser-dynamic": "21.2.17",
    "@angular/router": "21.2.17",
    "@ngrx/component-store": "21.1.1",
    "@ngrx/effects": "21.1.1",
    "@ngrx/entity": "21.1.1",
    "@ngrx/operators": "21.1.1",
    "@ngrx/router-store": "21.1.1",
    "@ngrx/store": "21.1.1",
    "@ngrx/store-devtools": "21.1.1",
    "@ngx-translate/core": "18.0.0",
    "@ngx-translate/http-loader": "18.0.0",
    "@primeuix/styled": "0.7.4",
    "@primeuix/utils": "0.6.3",
    "@primeuix/styles": "2.0.2",
    "@primeuix/motion": "0.0.10",
    "@primeuix/themes": "2.0.3",
    "bootstrap": "5.3.3",
    "date-fns": "4.1.0",
    "date-fns-tz": "3.2.0",
    "highcharts": "12.2.0",
    "highcharts-angular": "5.0.0",
    "ibantools": "^4.5.4",
    "keycloak-angular": "21.0.0",
    "primeflex": "4.0.0",
    "keycloak-js": "26.2.4",
    "ngx-matomo-client": "9.0.1",
    "popper.js": "1.16.1",
    "primeicons": "7.0.0",
    "primeng": "21.1.4",
    "pu-core-library": "0.4.6",
    "rxjs": "7.8.1",
    "tslib": "2.8.1",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular-builders/jest": "21.0.3",
    "@angular-eslint/builder": "21.3.1",
    "@angular-eslint/eslint-plugin": "21.3.1",
    "@angular-eslint/eslint-plugin-template": "21.3.1",
    "@angular-eslint/schematics": "21.3.1",
    "@angular-eslint/template-parser": "21.3.1",
    "@angular/build": "21.2.17",
    "@angular/cli": "21.2.17",
    "@angular/compiler-cli": "21.2.17",
    "@types/jest": "30.0.0",
    "@typescript-eslint/eslint-plugin": "8.4.0",
    "@typescript-eslint/parser": "8.4.0",
    "eslint": "9.26.0",
    "eslint-config-prettier": "8.10.0",
    "eslint-plugin-prettier": "4.2.1",
    "husky": "8.0.3",
    "jest": "30.3.0",
    "jest-preset-angular": "16.1.5",
    "jest-environment-jsdom": "30.4.1",
    "lint-staged": "13.3.0",
    "ng-mocks": "14.15.2",
    "prettier": "2.8.8",
    "rxjs-marbles": "7.0.1",
    "ts-jest": "29.4.11",
    "typescript": "5.9.3"
  }
}
